export default "__VITE_ASSET__8c8ad53e__"